import React, { useCallback, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import styles from "./PdfViewer.module.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useRef, useEffect } from "react";
import { connect } from "react-redux";
import {
  Box,
  ButtonGroup,
  HStack,
  IconButton,
  Input,
  flexbox,
  Tooltip,
  Spinner,
  Text
} from "@chakra-ui/react";
import { Resize1, Resize2, TwoPage, ZoomIn, ZoomOut } from "./icons";
// import Loading from "./Loading";


if (pdfjs.version === "2.16.105" && window.location.hostname !== "localhost") {
  var url = "/static/js/pdf.worker.min.js";
} else {
  url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
}
pdfjs.GlobalWorkerOptions.workerSrc = url;

const pdfHighlightId = "pdf_highlighted_text";

function highlightPattern(text, pattern) {
  return text.replace(
    pattern,
    (value) => `<mark id="${pdfHighlightId}">${value}</mark>`
  );
}

// function getTextItemWithNeighbors(textItems, itemIndex, span = 1) {
//   console.log(textItems, itemIndex);
//   window.t = textItems;
//   return textItems.slice(
//     Math.max(0, itemIndex - span),
//     itemIndex + 1 + span
//   )
//     .filter(Boolean)
//     .map(item => item.str)
//     .join('');
// }

// function getIndexRange(string, substring) {
//   const indexStart = string.indexOf(substring);
//   const indexEnd = indexStart + substring.length;

//   return [indexStart, indexEnd];
// }

const PdfViewer = (props) => {
  const [numPages, setNumPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  // const [secondpage, setsecondpage] = useState(2);
  const ref = useRef(null);
  const pageref = useRef(null);
  const scale = props.scale !== undefined ? props.scale : 0.2;
  const setScale = (newScale) => {
    if (props.control) {
      props.control(prev => ({
        ...prev,
        scale: typeof newScale === 'function' ? newScale(scale) : newScale
      }));
    }
  };
  const [twoPageView, setTwoPageView] = useState(false);

  const textRenderer = useCallback(
    (textItem) => highlightPattern(textItem.str, props.pdfsearch),
    [props.pdfsearch]
  );

  // const [textItems, setTextItems] = useState();

  // const onPageLoadSuccess = useCallback(async page => {
  //   const textContent = await page.getTextContent();
  //   setTextItems(textContent.items);
  // }, []);

  // console.log(textItems);


  // const textRenderer = useCallback((textItem, textItems) => {
  //   if (!textItem) {
  //     return;
  //   }
  //   const { itemIndex } = textItem;
  //   const matchInTextItem = textItem.str.match(props.pdfsearch);
  //   if (matchInTextItem) {
  //     // Found full match within current item, no need for black magic
  //     return highlightPattern(textItem.str, props.pdfsearch);
  //   }
  //   // Full match within current item not found, let's check if we can find it
  //   // spanned across multiple lines

  //   // Get text item with neighbors
  //   const textItemWithNeighbors = getTextItemWithNeighbors(textItem, itemIndex);
  //   console.log("BV");
  //   // const matchInTextItemWithNeighbors = textItemWithNeighbors.match(props.pdfsearch);

  //   // // if (!matchInTextItemWithNeighbors) {
  //   // //   // No match
  //   // //   return textItem.str;
  //   // // }

  //   // Now we need to figure out if the match we found was at least partially
  //   // in the line we're currently rendering
  //   const [matchIndexStart, matchIndexEnd] = getIndexRange(textItemWithNeighbors, props.pdfsearch);
  //   const [textItemIndexStart, textItemIndexEnd] = getIndexRange(textItemWithNeighbors, textItem.str);

  //   if (
  //     // Match entirely in the previous line
  //     matchIndexEnd < textItemIndexStart ||
  //     // Match entirely in the next line
  //     matchIndexStart > textItemIndexEnd
  //   ) {
  //     return textItem.str;
  //   }

  //   // Match found was partially in the line we're currently rendering. Now
  //   // we need to figure out what does "partially" exactly mean

  //   // Find partial match in a line
  //   const indexOfCurrentTextItemInMergedLines = textItemWithNeighbors.indexOf(textItem.str);

  //   const matchIndexStartInTextItem = Math.max(0, matchIndexStart - indexOfCurrentTextItemInMergedLines);
  //   const matchIndexEndInTextItem = matchIndexEnd - indexOfCurrentTextItemInMergedLines;

  //   const partialStringToHighlight = textItem.str.slice(matchIndexStartInTextItem, matchIndexEndInTextItem);
  //   console.log(textItem.str);

  //   return highlightPattern(textItem.str, partialStringToHighlight);
  // }, [props.pdfsearch]);

  // let file;
  // if (props.data) {
  //   file = props.data;
  // } else {
  //   file = "Loading.....";
  // }
  // console.log(props.data)
  useEffect(() => {
    let isScrollingTimeout = null;
    const isScrolling = () => {
      clearTimeout(isScrollingTimeout);
      isScrollingTimeout = setTimeout(() => {
        // const totalpage = numPages;
        let pageht;
        if (!props.pdfContainer?.current) return;
        const scrollPos = props.pdfContainer.current.scrollTop;
        if (pageref.current) {
          pageht = pageref.current.clientHeight;
        }
        if (twoPageView) {
          let currentPage = Math.floor(scrollPos / pageht) + 1;
          let twopage = currentPage * 2 - 1;
          // if (currentPage <= totalpage / 2) {
          //   setsecondpage(twopage + 1);
          // } else {
          //   setsecondpage("-");
          // }
          setCurrentPage(twopage);
        } else {
          let currentPage = Math.floor(scrollPos / pageht) + 1;
          setCurrentPage(currentPage);
        }
      }, 100);
    };

    if (ref.current) {
      ref.current.addEventListener("wheel", isScrolling);
    }

    return () => {
      if (ref.current) {
        ref.current.removeEventListener("wheel", isScrolling);
      }
      clearTimeout(isScrollingTimeout);
    };
  }, [twoPageView, props.pdfContainer]);

  const hasScrolledToHighlight = useRef(false);

  useEffect(() => {
    hasScrolledToHighlight.current = false;
  }, [props.pdfsearch]);

  function scrollIntoView() {
    var highlightElement = document.getElementById(pdfHighlightId);
    if (highlightElement) {
      if (highlightElement.innerText !== "") {
        document.getElementById(pdfHighlightId).scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center",
        });
        hasScrolledToHighlight.current = true;
      }
    }
  }

  const navtopage = () => {
    if (currentPage > 0 && currentPage <= numPages && props.pdfContainer?.current && pageref.current) {
      let pageht = pageref.current.clientHeight;
      props.pdfContainer.current.scrollTop = pageht * (currentPage - 1);
      document.activeElement.blur();
    }
  };

  function selectText() {
    props.pdfSearch("");
    props.latexSearch(window.getSelection().toString());
  }

  const twoPageToggle = () => {
    setTwoPageView(!twoPageView);
  };

  function onLoadSuccess({ numPages }) {
    setNumPages(numPages);
    if (props.pdfContainer && props.prevScroll > 0) {
      let attempts = 0;
      const tryScroll = () => {
        if (props.pdfContainer?.current) {
          const container = props.pdfContainer.current;
          container.scrollTo(0, props.prevScroll);

          const currentScroll = container.scrollTop;
          const maxScroll = container.scrollHeight - container.clientHeight;


          const reachedTarget = Math.abs(currentScroll - props.prevScroll) < 5;
          const reachedEnd = container.scrollHeight > container.clientHeight + 100 && Math.abs(currentScroll - maxScroll) < 5;

          if (!reachedTarget && !reachedEnd && attempts < 25) {
            attempts++;
            // Rapid attempts early on, then slow down
            const delay = attempts < 10 ? 100 : 400;
            setTimeout(tryScroll, delay);
          } else {
            // FINAL STEP: Release the guard so App.js starts listening to scroll again
            if (props.setPdfStatus) {
              props.setPdfStatus({ loading: false, error: null });
            }
          }
        } else {
          // No container, release anyway to prevent stuck state
          if (props.setPdfStatus) props.setPdfStatus({ loading: false, error: null });
        }
      };
      // Start immediately and check frequently
      setTimeout(tryScroll, 50);
      setTimeout(tryScroll, 200);
      setTimeout(tryScroll, 500);
    } else {
      // No scroll to restore, release immediately
      if (props.setPdfStatus) props.setPdfStatus({ loading: false, error: null });
    }
  }

  function onLoadError(error) {
    console.error("PDF Load Error:", error);
    if (props.setPdfStatus) {
      props.setPdfStatus({ loading: false, error: "Error rendering PDF" });
    }
  }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.altKey) && e.key === "-") {

        setScale(prev => {
          const next = prev - 0.1;
          return next <= 0 ? 0 : next;//zero check
        })
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.altKey) && e.key === "=") {

        setScale(prev => prev + 0.1);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    if (!props.pdfsearch) return;
    const timer = setTimeout(() => {
      const highlightElement = document.getElementById(pdfHighlightId);
      if (highlightElement && highlightElement.innerText !== "") {
        highlightElement.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center",
        });
      }
    }, 600);
    return () => clearTimeout(timer);
  }, [props.pdfsearch]);


  return (
    <div className={styles.document_outer}>
      <div className={styles.header}>
        <HStack
          backgroundColor="black"
          justifyContent="space-between"
          h="48px"
          width="auto"
          zIndex={10}
        >
          <ButtonGroup spacing="1" alignItems={"center"}>
            <Box display={"flex"} alignItems={"center"} ml={2}>

              <Input
                aria-label="enter page"
                style={{
                  display: flexbox,
                  textAlign: "center",
                  height: "38px",
                  width: "38px",
                  backgroundColor: "var(--secondary-main)",
                  color: "white",
                  border: "none",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "3px",
                }}
                value={twoPageView ? `${currentPage}` : currentPage}
                onChange={(e) => {
                  setCurrentPage(e.target.value);
                  setTwoPageView(false);
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    navtopage();
                  }
                }}
              ></Input>
              <Box
                style={{
                  height: "48px",
                  width: "48px",
                  color: "white",
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                }}
              >
                &nbsp; / {numPages}
              </Box>
            </Box>

            <hr style={{ height: "30px", width: "2px", background: "var(--border)", opacity: "50%", marginTop: "auto", marginBottom: "auto" }}></hr>

            <Tooltip label="Two page view">
              <IconButton
                onClick={() => twoPageToggle()}
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Text to Italic"
                icon={<TwoPage />}
                bg={twoPageView ? "var(--secondary-main)" : "var(--primary-main)"}
                _hover={{ bg: "var(--primary-main)" }}
              />
            </Tooltip>
            <hr style={{ height: "30px", width: "2px", background: "var(--border)", opacity: "50%", marginTop: "auto", marginBottom: "auto" }}></hr>
            <HStack spacing={2} align="center">

              {/* Zoom Out */}
              <Tooltip label="Zoom Out">
                <IconButton
                  id="zoomout"
                  onClick={() => {
                    if (scale > 0.05) setScale(scale - 0.1);
                  }}
                  color="white"
                  size="md"
                  bg="black"
                  aria-label="Zoom-Out"
                  icon={<ZoomOut />}
                  _hover={{ bg: "var(--primary-main)" }}
                />
              </Tooltip>

              {/* Zoom Percentage */}
              <Box
                minW="50px"
                textAlign="center"
                fontWeight="medium"
                color="white"
                // border="1px solid #f47c0d"
                borderRadius="md"
                px={2}
                py={1}
                bg="var(--secondary-main)"
              >
                {Math.round(scale / 0.2 * 100)}%
              </Box>

              {/* Zoom In */}
              <Tooltip label="Zoom In">
                <IconButton
                  id="zoomin"
                  onClick={() => setScale(scale + 0.1)}
                  size="md"
                  bg="black"
                  aria-label="Zoom-In"
                  icon={<ZoomIn />}
                  _hover={{ bg: "var(--primary-main)" }}
                />
              </Tooltip>
            </HStack>
          </ButtonGroup>

          <Box flex="1" display="flex" justifyContent="center" alignItems="center">
            {props.pdfStatus?.loading && (
              <HStack spacing={2}>
                <Spinner size="xs" color="white" />
                <Text color="white" fontSize="xs">Loading PDF...</Text>
              </HStack>
            )}
            {props.pdfStatus?.error && (
              <Text color="red.300" fontSize="xs" fontWeight="bold">
                {props.pdfStatus.error}
              </Text>
            )}
          </Box>

          {props.pdfFull ? (
            <Tooltip label="Minimize PDF">
              <IconButton
                onClick={() => {
                  props.toggleEditor();
                }}
                size="lg"
                bg="var(--secondary-main)"
                aria-label="Resize pdf"
                icon={<Resize2 />}
                _hover={{ bg: "var(--primary-main)" }}
              ></IconButton>
            </Tooltip>
          ) : (
            <Tooltip label="Maximize PDF">
              <IconButton
                onClick={() => {
                  props.toggleEditor();
                  // setClientWidth(1);
                }}
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Resize pdf"
                icon={<Resize1 />}
                bg="var(--secondary-main)"
                _hover={{ bg: "var(--primary-main)" }}
              ></IconButton>
            </Tooltip>
          )}

        </HStack>
      </div >

      <div
        className={twoPageView ? styles.twopageview : styles.document_viewer}
        ref={props.pdfContainer}
        onScroll={(e) => {
          if (props.onScroll) {
            props.onScroll(e.target.scrollTop);
          }
        }}
      >
        <Document
          file={props.data}
          onLoadSuccess={onLoadSuccess}
          onLoadError={onLoadError}
          className={""} // Restyled by wrapper above
        >
          {Array.apply(null, Array(numPages))
            .map((x, i) => i + 1)
            .map((page, i) => (
              <div key={i} className={styles.pagedom} ref={pageref}>
                <Page
                  className={styles.viewer}
                  onMouseUp={selectText}
                  pageNumber={page}
                  scale={0.9 + scale}
                  // onRenderTextLayerSuccess={
                  //   scrollIntoView
                  // }
                  customTextRenderer={textRenderer}
                  data-page={page}
                // onLoadSuccess={onPageLoadSuccess}
                // onPageChange={({ pageNumber }) => onPageChange(pageNumber)}
                />
              </div>
            ))}
        </Document>
      </div>
    </div >
  );
};

const mapStateToProps = (state) => ({
  pdfsearch: state.pdfsearch.pdfSearch,
});

const mapDispatchToProps = (dispatch) => {
  return {
    latexSearch: (data) => dispatch({ type: "latexSearch", payload: data }),
    pdfSearch: (data) => dispatch({ type: "pdfSearch", payload: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PdfViewer);
